import Portfolios from "./Portfolios.container";

export default Portfolios;
